import { render, staticRenderFns } from "./corporateDashboard.vue?vue&type=template&id=171d4f8c&"
import script from "./corporateDashboard.vue?vue&type=script&lang=js&"
export * from "./corporateDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports